<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-col class="p-0">
        <label>Transportadora</label>
        <multiselect
          v-model="transportadoraSelected"
          :options-limit="300"
          :limit="2"
          :limit-text="limitText"
          :options="optionsTransportadora"
          track-by="value"
          label="label"
          id="transportadora"
          placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :searchable="true"
          :loading="isLoadingTransportadora"
          @search-change="listaTransportadora"
        ></multiselect>
        <b-form-feedback
          v-text="form.errors.get('pessoa_id_for')"
          v-if="form.errors.has('pessoa_id_for')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Unidade Parceira</label>
        <multiselect
          v-model="pessoaParceiraSelected"
          :options="this.$parent.optionsPessoaParceira"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :disabled="enableButton"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('pespar_id')"
          v-if="form.errors.has('pespar_id')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Unidade Transporte</label>
        <multiselect
          v-model="meioTranspSelected"
          :options="this.$parent.optionsTpRodado"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :disabled="
            this.form.pessoa_id == '' || this.form.pessoa_id == undefined
          "
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('meiotransp_id')"
          v-if="form.errors.has('meiotransp_id')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Meio Transporte primário</label>
        <multiselect
          v-model="meioTranspPrimarioSelected"
          :options="optionsMeioTranspPrimario"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :disabled="
            this.form.meiotransp_id == '' ||
            this.form.meiotransp_id == undefined
          "
          @input="
            populaMeioTranspSecundario(meioTranspPrimarioSelected);
            populaMeioTranspTerciario(meioTranspPrimarioSelected);
            populaMotoristas(meioTranspPrimarioSelected);
          "
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('meiotransp_id_pri')"
          v-if="form.errors.has('meiotransp_id_pri')"
        ></b-form-feedback>
      </b-col>
      <b-col v-if="this.form.tp_rodado_pri == 3" class="p-0">
        <label>Meio Transporte secundário</label>
        <multiselect
          v-model="meioTranspSecundarioSelected"
          :options="optionsMeioTranspSecundario"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('meiotransp_id_sec')"
          v-if="form.errors.has('meiotransp_id_sec')"
        ></b-form-feedback>
      </b-col>
      <b-col v-if="this.form.tp_rodado_pri == 3" class="p-0">
        <label>Meio Transporte terciário</label>
        <multiselect
          v-model="meioTranspTerciarioSelected"
          :options="optionsMeioTranspTerciario"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('meiotransp_id_ter')"
          v-if="form.errors.has('meiotransp_id_ter')"
        ></b-form-feedback>
      </b-col>
      <b-col
        v-if="
          optionsMotoristas.length > 0 ||
          this.form.meiotransp_id_pri != '' ||
          this.form.meiotransp_id_pri != undefined
        "
        class="p-0"
      >
        <label>Motorista</label>
        <multiselect
          v-model="motoristaSelected"
          :options="optionsMotoristas"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :disabled="
            this.form.meiotransp_id_pri == '' ||
            this.form.meiotransp_id_pri == undefined
          "
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('veimot_id')"
          v-if="form.errors.has('veimot_id')"
        ></b-form-feedback>
      </b-col>
      <b-col
        v-if="
          optionsMotoristas.length > 0 ||
          this.form.meiotransp_id_pri != '' ||
          this.form.meiotransp_id_pri != undefined
        "
        class="p-0"
      >
        <label>Motorista - Secundario</label>
        <multiselect
          v-model="motoristaSecundarioSelected"
          :options="optionsMotoristas"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :disabled="
            this.form.meiotransp_id_pri == '' ||
            (this.form.meiotransp_id_pri == undefined &&
              this.motoristaSelected == '') ||
            this.motoristaSelected == undefined
          "
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('veimot_id_sec')"
          v-if="form.errors.has('veimot_id_sec')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Ajudante</label>
        <multiselect
          v-model="ajudantes"
          :options="this.$parent.optionsAjudantes"
          track-by="value"
          label="label"
          :limit="3"
          :max="3"
          :hide-selected="true"
          :multiple="true"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('carmeitranaju_id')"
          v-if="form.errors.has('carmeitranaju_id')"
        ></b-form-feedback>
      </b-col>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import accounting from "accounting";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      optionsAjudantes: [],
      optionsMeioTranspPrimario: [],
      motoristaSelected: [],
      motoristaSecundarioSelected: [],
      optionsMotoristas: [],
      meioTranspSelected: [],
      transportadoraSelected: [],
      meioTranspPrimarioSelected: [],
      meioTranspSecundarioSelected: [],
      meioTranspTerciarioSelected: [],
      tpCargaSelected: [],
      loading: false,
      isDisabled: false,
      disableMeioTranspPri: true,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      ajudantes: [],
      ajudante: [],
      enableButton: false,
      isLoadingTransportadora: false,
      optionsTipoCarga: [],
      pessoaParceiraSelected: [],
      optionsTransportadora: [],
      optionsMeioTranspSecundario: [],
      optionsMeioTranspTerciario: [],
      errors_array: [],
      docfis: [{ docfis_id: "" }],
      form: new Form({
        docfis: [],
        pespar_id: "",
        carga_id: "",
        carmeitran_id: "",
        pessoa_id: "",
        meiotransp_id: "",
        meiotransp_id_pri: "",
        tp_rodado_pri: "",
        meiotransp_id_sec: "",
        meiotransp_id_ter: "",
        veimot_id: "",
        veimot_id_sec: "",
        veimot_id: "",
        veiculo_id: "",
        ajudante: [
          {
            pessoa_id: "",
            status: "",
            carmeitranaju_id: "",
          },
        ],
      }),
      helpForm: new Form({ search: "" }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    meioTranspSelected(obj) {
      obj != null
        ? (this.form.meiotransp_id = obj.value)
        : (this.form.meiotransp_id = "");
      this.populaMeioTranspPrimario(obj.tp_rodado, obj.dados);
    },
    transportadoraSelected(obj) {
      obj != null
        ? (this.form.pessoa_id = obj.value)
        : (this.form.pessoa_id = "");
    },
    pessoaParceiraSelected(obj) {
      obj != null
        ? (this.form.pespar_id = obj.value)
        : (this.form.pespar_id = "");
    },
    meioTranspPrimarioSelected(obj) {
      if (obj != null) {
        this.form.meiotransp_id_pri = obj.value;
        this.form.tp_rodado_pri = obj.tp_rodado;
        this.form.veiculo_id = obj.veiculo_id;
        this.populaMotoristas(obj);
      } else {
        this.form.meiotransp_id_pri = "";
        this.form.tp_rodado_pri = "";
        this.form.veiculo_id = "";
        this.motoristaSelected = [];
        this.motoristaSecundarioSelected = [];
      }
    },
    meioTranspSecundarioSelected(obj) {
      obj != null
        ? (this.form.meiotransp_id_sec = obj.value)
        : (this.form.meiotransp_id_sec = "");
    },
    meioTranspTerciarioSelected(obj) {
      obj != null
        ? (this.form.meiotransp_id_ter = obj.value)
        : (this.form.meiotransp_id_ter = "");
    },
    motoristaSelected(obj) {
      obj != null
        ? (this.form.veimot_id = obj.value)
        : (this.form.veimot_id = "");
    },
    motoristaSecundarioSelected(obj) {
      obj != null
        ? (this.form.veimot_id_sec = obj.value)
        : (this.form.veimot_id_sec = "");
    },
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.carga_id);
      }
    },
    onCreate(data) {
      this.docfis = [];
      this.errors_array = "";
      this.errors_array = [];
      this.transportadoraSelected = [];
      this.pessoaParceiraSelected = [];
      this.meioTranspSelected = [];
      this.meioTranspPrimarioSelected = [];
      this.meioTranspSecundarioSelected = [];
      this.meioTranspTerciarioSelected = [];
      this.motoristaSelected = [];
      this.motoristaSecundarioSelected = [];
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Editar Carga";
      this.modal_botao = "Editar Carga";
      this.modal_acao = "i";
      this.form.reset();
      this.$refs.modal_form.show();
    },
    onEdit(data) {
      this.docfis = [];
      this.errors_array = "";
      this.errors_array = [];
      this.ajudantes = [];
      this.ajudante = [];
      this.form.ajudante = [];
      this.meioTranspSelected = [];
      this.transportadoraSelected = [];
      this.meioTranspPrimarioSelected = [];
      this.meioTranspSecundarioSelected = [];
      this.meioTranspTerciarioSelected = [];
      this.optionsMeioTranspPrimario = [];
      this.optionsMeioTranspSecundario = [];
      this.optionsMeioTranspTerciario = [];
      this.pessoaParceiraSelected = [];
      this.pessoaParceiraSelected = [];
      this.optionsMotoristas = [];
      this.pessoaParceiraSelected = [];
      this.meioTranspPrimarioSelected = [];
      this.meioTranspSecundarioSelected = [];
      this.meioTranspTerciarioSelected = [];
      this.motoristaSelected = [];
      this.motoristaSecundarioSelected = [];
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Editar Carga";
      this.modal_botao = "Editar Carga";
      this.modal_acao = "u";
      this.form.reset();
      this.disableMeioTranspPri = true;
      this.enableButton = !data.pesparRed && !data.hasOcorrenChegada;
      this.form.carga_id = data.cargaId;
      this.form.carmeitran_id = data.cargaMeioTransp.carmeitranId;
      if (
        data.cargaMeioTransp != null &&
        data.cargaMeioTransp.cargaMeioTranspAjudante.length > 0
      ) {
        data.cargaMeioTransp.cargaMeioTranspAjudante.forEach((obj) => {
          this.ajudantes.push({
            label: obj.pessoa.pessoaFisica.nome,
            pessoa_id: obj.pessoa.pessoaFisica.pessoaId,
            value: obj.carmeitranajuId,
            status: obj.status.valor,
            carmeitranaju_id: obj.carmeitranajuId,
          });
        });
      }
      if (
        data.cargaMeioTransp != null &&
        data.cargaMeioTransp.paramTipoRodado != null
      ) {
        this.meioTranspSelected = {
          label:
            data.cargaMeioTransp.paramTipoRodado.descr +
            " - " +
            this.formatNumber(
              data.cargaMeioTransp.paramTipoRodado.capacidadePeso
            ),
          value: data.cargaMeioTransp.paramTipoRodado.partiprodId,
          tp_rodado: data.cargaMeioTransp.paramTipoRodado.tpRodado,
          dados: data,
        };
      }
      if (data.pessoaParceira != null) {
        this.pessoaParceiraSelected = {
          label: data.pessoaParceira.descr,
          value: data.pessoaParceira.pesparId,
        };
      }
      if (data.pessoa != null) {
        if (data.pessoa.pessoaJuridica != null) {
          this.transportadoraSelected = {
            label:
              "PJ -" +
              data.pessoa.cd +
              " - " +
              data.pessoa.pessoaJuridica.razaoSocial +
              " - " +
              this.onFormataCnpj(
                data.pessoa.pessoaJuridica.cnpjBase,
                data.pessoa.pessoaJuridica.cnpjFilial,
                data.pessoa.pessoaJuridica.cnpjDigito
              ) +
              " - " +
              data.pessoa.pessoaJuridica.inscricaoEstadual,
            value: data.pessoa.pessoaJuridica.pessoaId,
            valida_opentech: data.pessoa.validaOpentech,
          };
        }
        if (data.pessoa.pessoaFisica != null) {
          this.transportadoraSelected = {
            label:
              "PF -" +
              data.pessoa.pessoaFisica.nome +
              " - " +
              data.pessoa.pessoaFisica.cpf,
            value: data.pessoa.pessoaFisica.pessoaId,
            valida_opentech: data.pessoa.validaOpentech,
          };
        }
        if (data.pessoa.pessoaExterior != null) {
          this.transportadoraSelected = {
            label:
              "PE -" +
              data.pessoa.pessoaExterior.nome +
              " - " +
              data.pessoa.pessoaExterior.cd,
            value: data.pessoa.pessoaExterior.pessoaId,
            valida_opentech: data.pessoa.validaOpentech,
          };
        }
      }

      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.docfis = this.docfis;
      this.form
        .put("/api/montagemcarga/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
          this.docfis = [];
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.ajudante = this.ajudantes;
      this.form
        .patch("/api/expedicao/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  nome: obj.razao_social,
                  cpf: null,
                  cnpj: this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ),
                  ie: obj.inscricao_estadual,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  valida_opentech: obj.pessoa.valida_opentech,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  nome: obj.nome,
                  cpf: null,
                  cnpj: obj.cuit,
                  ie: null,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  valida_opentech: obj.pessoa.valida_opentech,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    populaMeioTranspPrimario(data, dados) {
      this.meioTranspPrimarioSelected = [];
      this.meioTranspSecundarioSelected = [];
      this.meioTranspTerciarioSelected = [];
      this.motoristaSelected = [];
      this.motoristaSecundarioSelected = [];
      this.errors_array = [];
      this.optionsMeioTranspPrimario = [];
      this.optionsMeioTranspSecundario = [];
      this.optionsMeioTranspTerciario = [];
      this.optionsMotoristas = [];
      let veiculosDescartados = 0;
      let transportadoraId = null;
      if (this.transportadoraSelected) {
          transportadoraId = this.transportadoraSelected.value;
      }
      //Primario
      this.$parent.optionsVeiculo.forEach((item, i) => {
        if (item.pessoa_id_agenciador != transportadoraId) {
          veiculosDescartados++;
        }
        if (item.tp_rodado == data && item.pessoa_id_agenciador == transportadoraId) {
          if (this.transportadoraSelected.valida_opentech == 1) {
            if (item.ultima_situacao) {
              var dataNew = new Date();
              var dateExpiracao = new Date(item.ultima_situacao.dt_expiracao);
              if (
                (item.ultima_situacao.tp_situacao == 2 ||
                  item.ultima_situacao.tp_situacao == 11 ||
                  item.ultima_situacao.tp_situacao == 12 ||
                  item.ultima_situacao.tp_situacao == 7) &&
                dateExpiracao >= dataNew
              ) {
                this.optionsMeioTranspPrimario.push({
                  label: item.label,
                  value: item.meiotransp_id,
                  tp_rodado: item.tp_rodado,
                  veiculo_id: item.veiculo_id,
                  ultima_situacao: item.ultima_situacao,
                });
              }
            }
          } else {
            this.optionsMeioTranspPrimario.push({
              label: item.label,
              value: item.meiotransp_id,
              tp_rodado: item.tp_rodado,
              veiculo_id: item.veiculo_id,
              ultima_situacao: item.ultima_situacao,
            });
          }
        }
      });
      if (
        Object.keys(this.meioTranspSelected).length > 0 && // se tem algum tp_rodado selecionado
        this.optionsMeioTranspPrimario.length == 0 && // se não achou opções
        veiculosDescartados > 0 // e descartou veículos por causa da transportadora
      ) {
        this.$Simplert.open({
          title: "Erro",
          message: "Nenhum veículo encontrado para essa transportadora selecionada.",
          customCloseBtnText: "Fechar",
          type: "error",
        });
      }
      if (dados != null) {
        if (dados.cargaMeioTransp.meioTransportePrimario !== null) {
          this.meioTranspPrimarioSelected = {
            label: dados.cargaMeioTransp.meioTransportePrimario.veiculo.placa,
            value: dados.cargaMeioTransp.meioTransportePrimario.meiotranspId,
            tp_rodado:
              dados.cargaMeioTransp.meioTransportePrimario.veiculo
                .paramTipoRodado.tpRodado,
            veiculo_id: dados.cargaMeioTransp.meioTransportePrimario.veiculoId,
          };
          this.motoristaSelected = {
            label:
              dados.cargaMeioTransp.meioTransportePrimario.veiculo
                .veiculoMotorista[0].pessoaMotorista.pessoaFisica.nome +
              " - " +
              dados.cargaMeioTransp.meioTransportePrimario.veiculo
                .veiculoMotorista[0].pessoaMotorista.pessoaFisica.cpf,
            value:
              dados.cargaMeioTransp.meioTransportePrimario.veiculo
                .veiculoMotorista[0].veimotId,
          };
        }
        if (dados.cargaMeioTransp.veiculoMotoristaSecundario != null) {
          this.motoristaSecundarioSelected = {
            label:
              dados.cargaMeioTransp.veiculoMotoristaSecundario.pessoaMotorista
                .pessoaFisica.nome +
              " - " +
              dados.cargaMeioTransp.veiculoMotoristaSecundario.pessoaMotorista
                .pessoaFisica.cpf,
            value: dados.cargaMeioTransp.veiculoMotoristaSecundario.veimotId,
          };
        }
        if (dados.cargaMeioTransp.meioTransporteSecundario !== null) {
          this.meioTranspSecundarioSelected = {
            label: dados.cargaMeioTransp.meioTransporteSecundario.veiculo.placa,
            value: dados.cargaMeioTransp.meioTransporteSecundario.meiotranspId,
            tp_rodado:
              dados.cargaMeioTransp.meioTransporteSecundario.veiculo
                .paramTipoRodado.tpRodado,
            veiculo_id:
              dados.cargaMeioTransp.meioTransporteSecundario.veiculoId,
          };
        }
        if (dados.cargaMeioTransp.meioTransporteTerciario !== null) {
          this.meioTranspTerciarioSelected = {
            label: dados.cargaMeioTransp.meioTransporteTerciario.veiculo.placa,
            value: dados.cargaMeioTransp.meioTransporteTerciario.meiotranspId,
            tp_rodado:
              dados.cargaMeioTransp.meioTransporteTerciario.veiculo
                .paramTipoRodado.tpRodado,
            veiculo_id: dados.cargaMeioTransp.meioTransporteTerciario.veiculoId,
          };
        }
      }
    },
    populaMeioTranspSecundario(data) {
      this.meioTranspSecundarioSelected = [];
      this.optionsMeioTranspSecundario = [];
      let transportadoraId = null;
      if (this.transportadoraSelected) {
        transportadoraId = this.transportadoraSelected.value;
      }
      if (data.tp_rodado == 3) {
        //cavalo mecanico
        //Secundario
        this.$parent.optionsVeiculo.forEach((item, i) => {
          if (item.tp_rodado != 3 && item.pessoa_id_agenciador == transportadoraId) {
            if (this.transportadoraSelected.valida_opentech == 1) {
              if (item.ultima_situacao) {
                var dataNew = new Date();
                var dateExpiracao = new Date(item.ultima_situacao.dt_expiracao);
                if (
                  (item.ultima_situacao.tp_situacao == 2 ||
                  item.ultima_situacao.tp_situacao == 11 ||
                  item.ultima_situacao.tp_situacao == 12 ||
                  item.ultima_situacao.tp_situacao == 7) &&
                  dateExpiracao >= dataNew
                ) {
                  this.optionsMeioTranspSecundario.push({
                    label: item.label,
                    value: item.meiotransp_id,
                    tp_rodado: item.tipo_rodado,
                    veiculo_id: item.veiculo_id,
                    ultima_situacao: item.ultima_situacao,
                  });
                }
              }
            } else {
              this.optionsMeioTranspSecundario.push({
                label: item.label,
                value: item.meiotransp_id,
                tp_rodado: item.tipo_rodado,
                veiculo_id: item.veiculo_id,
                ultima_situacao: item.ultima_situacao,
              });
            }
            //nao seja cavalo mecanico
          }
        });
      }
    },
    populaMeioTranspTerciario(data) {
      this.meioTranspTerciarioSelected = [];
      this.optionsMeioTranspTerciario = [];
      let transportadoraId = null;
      if (this.transportadoraSelected) {
        transportadoraId = this.transportadoraSelected.value;
      }
      if (data.tp_rodado == 3) {
        //cavalo mecanico
        //Terciario
        this.$parent.optionsVeiculo.forEach((item, i) => {
          if (item.tp_rodado != 3 && item.pessoa_id_agenciador == transportadoraId) {
            if (this.transportadoraSelected.valida_opentech == 1) {
              if (item.ultima_situacao) {
                var dataNew = new Date();
                var dateExpiracao = new Date(item.ultima_situacao.dt_expiracao);
                if (
                  (item.ultima_situacao.tp_situacao == 2 ||
                  item.ultima_situacao.tp_situacao == 11 ||
                  item.ultima_situacao.tp_situacao == 12 ||
                  item.ultima_situacao.tp_situacao == 7) &&
                  dateExpiracao >= dataNew
                ) {
                  this.optionsMeioTranspTerciario.push({
                    label: item.label,
                    value: item.meiotransp_id,
                    tp_rodado: item.tipo_rodado,
                    veiculo_id: item.veiculo_id,
                    ultima_situacao: item.ultima_situacao,
                  });
                }
              }
            } else {
              this.optionsMeioTranspTerciario.push({
                label: item.label,
                value: item.meiotransp_id,
                tp_rodado: item.tipo_rodado,
                veiculo_id: item.veiculo_id,
                ultima_situacao: item.ultima_situacao,
              });
            }
            //nao seja cavalo mecanico
          }
        });
      }
    },
    populaMotoristas(data) {
      this.errors_array = [];
      this.motoristaSelected = [];
      this.optionsMotoristas = [];
      this.$parent.optionsVeiculo.forEach((item, i) => {
        if (item.veiculo_id == data.veiculo_id) {
          if (item.veiculo_motorista.length > 0) {
            item.veiculo_motorista.forEach((item2, i2) => {
              if (item2.veiculo_id == data.veiculo_id) {
                if(this.isActive(item2)){
                  if (this.transportadoraSelected.valida_opentech == 1) {
                    if (
                      item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco !=
                      null
                    ) {
                      var dataNew = new Date();
                      var dateExpiracao = new Date(
                        item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco.dt_expiracao
                      );
                      if (
                        item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco
                          .tp_situacao == 2 &&
                        dateExpiracao >= dataNew
                      ) {
                        this.optionsMotoristas.push({
                          label:
                            item2.pessoa_motorista.pessoa_fisica.nome +
                            " - " +
                            item2.pessoa_motorista.pessoa_fisica.cpf,
                          value: item2.veimot_id,
                        });
                      } else {
                        this.errors_array.push({
                          erro: "Nenhum motorista com status RECOMENDADO para esse veiculo",
                        });
                      }
                    }
                  } else {
                    this.optionsMotoristas.push({
                      label:
                        item2.pessoa_motorista.pessoa_fisica.nome +
                        " - " +
                        item2.pessoa_motorista.pessoa_fisica.cpf,
                      value: item2.veimot_id,
                    });
                  }
                } else {
                  this.errors_array.push({
                          erro: "Nenhum motorista com status RECOMENDADO para esse veiculo",
                        });
                }
              }
                
              if (this.isActive(item2) && item2.is_padrao == 1) {
                if (this.transportadoraSelected.valida_opentech == 1) {
                  if (
                    item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco !=
                    null
                  ) {
                    var dataNew = new Date();
                    var dateExpiracao = new Date(
                      item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco.dt_expiracao
                    );
                    if (
                      item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco
                        .tp_situacao == 2 &&
                      dateExpiracao >= dataNew
                    ) {
                      this.motoristaSelected = {
                        label:
                          item2.pessoa_motorista.pessoa_fisica.nome +
                          " - " +
                          item2.pessoa_motorista.pessoa_fisica.cpf +
                          " - Motorista pré-cadastrado como padrão",
                        value: item2.veimot_id,
                      };
                    }
                  }
                } else {
                  this.motoristaSelected = {
                    label:
                      item2.pessoa_motorista.pessoa_fisica.nome +
                      " - " +
                      item2.pessoa_motorista.pessoa_fisica.cpf +
                      " - Motorista pré-cadastrado como padrão",
                    value: item2.veimot_id,
                  };
                }
              }
            });
          } else {
          }
        }
        if (
          this.optionsMotoristas.length <= 0 &&
          this.errors_array.length == 0 &&
          this.optionsMeioTranspPrimario.length > 0 &&
          this.meioTranspPrimarioSelected != null
        ) {
          if (this.transportadoraSelected.valida_opentech == 1) {
            this.errors_array.push({
              erro: "Nenhum motorista com status RECOMENDADO para esse veiculo.",
            });
          } else {
            this.errors_array.push({
              erro: "Nenhum motorista vinculado para esse veiculo.",
            });
          }
        } else {
          this.errors_array = [];
        }
      });
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    isActive(obj) {
      if (obj.status !== undefined && obj.status !== 1) {
        return false;
      }

      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            if (!this.isActive(obj[key])) {
              return false;
            }
          }
        }
      }

      return true;
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
